import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-maintenance",
  "use": "icon-status-maintenance-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-status-maintenance\"><path d=\"M8.852 4.254 7.038 6.056 5.224 4.254l-.988.981L6.05 7.037 4.236 8.839l.988.98 1.814-1.801L8.852 9.82l.987-.981-1.814-1.802L9.84 5.235ZM7.038.08C3.164.08.034 3.19.034 7.037s3.13 6.957 7.004 6.957 7.004-3.11 7.004-6.957S10.91.08 7.038.08m0 12.523c-3.09 0-5.604-2.498-5.604-5.566S3.95 1.47 7.038 1.47 12.64 3.97 12.64 7.037s-2.515 5.566-5.603 5.566\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol